import { FormEvent, useState } from 'react'
import { UserPlus } from 'lucide-react'
import { Alerta, Boton, Busqueda, Campo, Cargando, Dialogo, Entrada } from '../kit'
import { useAgregarPersona, useCambiarEncargado, usePersonas } from '../../queries/useInventario'
import { Recinto } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'

/**
 * El encargado de la oficina: se busca entre las personas que la app ya conoce o se
 * agrega por RUT (con sus datos de UCampus; si UCampus no la tiene, con los nombres que
 * se escriban). Cambiarlo deja la plancheta con modificaciones.
 */
export function DialogoEncargado({ recinto, onCerrar }: { recinto: Recinto; onCerrar: () => void }) {
  const [q, setQ] = useState('')
  const [rut, setRut] = useState('')
  const [nombres, setNombres] = useState('')
  const [apellidos, setApellidos] = useState('')
  const personas = usePersonas(q)
  const asignar = useCambiarEncargado()
  const agregar = useAgregarPersona()

  const elegir = (persona: number | null) => asignar.mutate({ codigo: recinto.codigo, persona }, { onSuccess: onCerrar })

  const agregarYAsignar = (e: FormEvent) => {
    e.preventDefault()
    agregar.mutate({ rut, nombres, apellidos }, { onSuccess: (persona) => elegir(persona.id) })
  }

  const error = asignar.error ?? agregar.error
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo={`Encargado de ${recinto.nombre}`}>
      <div className="pila">
        {recinto.encargado && (
          <div className="fila-simple">
            <span>
              Hoy: <strong>{recinto.encargado.nombre}</strong>
            </span>
            <Boton variante="text" color="error" tam="sm" onClick={() => elegir(null)} disabled={asignar.isPending}>Quitar</Boton>
          </div>
        )}

        <Busqueda etiqueta="Buscar persona por nombre o RUT" placeholder="Nombre o RUT" value={q} onChange={(e) => setQ(e.target.value)} data-autofocus />
        {personas.isFetching && <Cargando texto="Buscando…" />}
        {personas.data && q.trim().length >= 2 && (
          personas.data.length ? (
            <ul className="lista-elegir">
              {personas.data.map((p) => (
                <li key={p.id}>
                  <span>
                    {p.nombre}
                    <span className="tabla__sub">{p.rut_formateado || 'Sin RUT'}</span>
                  </span>
                  <Boton tam="sm" variante="outlined" onClick={() => elegir(p.id)} disabled={asignar.isPending || p.id === recinto.encargado?.id}>
                    {p.id === recinto.encargado?.id ? 'Actual' : 'Elegir'}
                  </Boton>
                </li>
              ))}
            </ul>
          ) : (
            <p className="texto-secundario">Nadie con ese nombre o RUT. Agrégala abajo con su RUT.</p>
          )
        )}

        <form className="pila subformulario" onSubmit={agregarYAsignar}>
          <h3 className="subformulario__titulo">Agregar por RUT</h3>
          <Campo etiqueta="RUT" requerido>
            <Entrada value={rut} onChange={(e) => setRut(e.target.value)} placeholder="12.345.678-5" required autoComplete="off" />
          </Campo>
          <div className="formulario-grilla">
            <Campo etiqueta="Nombres">
              <Entrada value={nombres} onChange={(e) => setNombres(e.target.value)} />
            </Campo>
            <Campo etiqueta="Apellidos">
              <Entrada value={apellidos} onChange={(e) => setApellidos(e.target.value)} />
            </Campo>
          </div>
          <p className="texto-secundario">Los datos se traen de UCampus; nombres y apellidos solo hacen falta si UCampus no la tiene.</p>
          <Boton type="submit" variante="outlined" icono={UserPlus} cargando={agregar.isPending} disabled={!rut.trim()}>Agregar y asignar</Boton>
        </form>

        {error && <Alerta tipo="error">{mensajeDeError(error)}</Alerta>}
      </div>
    </Dialogo>
  )
}
